import { useParams } from 'react-router-dom';
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect, useState } from 'react';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';
import sleep from 'sleep-promise';

function Form() {
    const profileFilter = chooseProfileFilter();
    const { id } = useParams();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;
    const path = 'governanceroom/clientscitiesprojects';

    const paths = {
        endpointSave: `${endpointBackend}${path}/save`,
        endpointGetById: `${endpointBackend}${path}/getById`,
        endpointGetAllObservatoryCities: `${endpointBackend}governanceroom/observatorycities/getall`,
        endpointGetAllObservatoryGroups: `${endpointBackend}governanceroom/observatorygroups/getall`,
        endpointGetAllReactProjectTypes: `${endpointBackend}governanceroom/reactprojecttypes/getall`,
        endpointGetObservatoriesByCity: `${endpointBackend}governanceroom/observatories/getByCity`,
        urlGoBack: `/${path}/list`,
        pathView: `/${path}/view`
    };

    const labels = {
        labelTitleAdd: 'Novo Projeto do Município',
        labelTitleEdit: 'Editar Projeto do Município',
        labelTitleView: 'Visualizar Projeto do Município'
    };

    const hiddenValues = {};

    if (profileFilter.core_application_instance_id) {
        hiddenValues.core_application_instance_id =
            profileFilter.core_application_instance_id;
    }

    const getForm = (values) => {
        let form = {
            hiddenValues: hiddenValues,
            fields: [
                {
                    name: 'governance_room_observatory_city_id',
                    type: 'select',
                    label: 'Município',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllObservatoryCities,
                        label: 'client_city_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...hiddenValues
                            }
                        }
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 6,
                    handleChange: async (element, field, values) => {
                        let form = getForm(values);
                        values.governance_room_observatory_id = null;
                        values.governance_room_observatory_group_id = null;
                        setForm(values);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />);
                    }
                },
                {
                    name: 'governance_room_observatory_id',
                    type: 'select',
                    label: 'Observatório',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetObservatoriesByCity,
                        label: 'name',
                        value: 'id',
                        params: {
                            filter: {
                                governance_room_observatory_city_id: values.governance_room_observatory_city_id
                            }
                        }
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 6,
                    handleChange: async (element, field, values) => {
                        let form = getForm(values);
                        values.governance_room_observatory_group_id = null;
                        setForm(values);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />);
                    }
                },
                {
                    name: 'governance_room_observatory_group_id',
                    type: 'select',
                    label: 'Grupo de Projeto',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllObservatoryGroups,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'type',
                    type: 'select',
                    label: 'Tipo de Projeto',
                    options: [
                        { label: 'Power BI', value: 'powerbi' },
                        { label: 'React Dashboard', value: 'reactdashboard' }
                    ],
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                    handleChange: async (element, field, values) => {
                        let form = getForm(values);
                        values.link = '';
                        setForm(values);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />);
                    }
                },
                (values.type === 'powerbi' || !values.type) ? {
                    label: 'Link',
                    type: 'text',
                    name: 'link',
                    maxLength: 1000,
                    validations: {
                        required: true
                    }
                } : {
                    label: 'Dashboard',
                    type: 'select',
                    name: 'link',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllReactProjectTypes,
                        label: 'name',
                        value: 'url'
                    },
                    validations: {
                        required: true
                    }
                },
                {
                    name: 'is_public',
                    type: 'select',
                    label: 'Projeto Público',
                    options: [
                        { label: 'Sim', value: '1' },
                        { label: 'Não', value: '0' }
                    ],
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    label: 'Título',
                    type: 'text',
                    name: 'title',
                    validations: {
                        required: true
                    },
                    maxLength: 140
                },
                {
                    label: 'Descrição',
                    type: 'text',
                    name: 'description',
                    validations: {
                        required: false
                    },
                    maxLength: 200
                },
                {
                    name: 'image',
                    type: "fileS3",
                    label: 'Imagem',
                    uploadPath: '/clientscities/portal',
                    extensionAccept: '.jpeg,.jpg,.png,.webp',
                    limitFileSize: 100,
                    validations: {
                        required: false
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels
        };
        form.values = values;
        return form;
    };

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id });
            }
            if (profileFilter.core_application_instance_id) {
                values.core_application_instance_id =
                    profileFilter.core_application_instance_id;
            }
            const form = getForm(values);

            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            );
        };
        load();
    }, []);

    return <div>{formContent}</div>;
}
export default Form;
